import React from 'react';
import { connect } from 'react-redux';
import { getActiveLanguage, withLocalize } from 'react-localize-redux';
import { langType } from '../constants/types';

const withLang = (Component) => {
  function wrapper({ lang, translate, ...rest }) {
    return (<Component lang={lang} translate={translate} {...rest} />) || null;
  }

  wrapper.propTypes = langType;

  wrapper.displayName = `withLang(${Component.displayName || Component.name})`;

  return wrapper;
};

const mapStateToProps = ({ localize }) => ({
  lang: getActiveLanguage(localize).code
});

export default (component) => connect(mapStateToProps)(withLocalize(withLang(component)));
export { langType } from '../constants/types';
